/*
 This file is used to get the backend url
*/

// For AWS, it's an empty string since the nginx will redirect all /api/request to localhost:8080 automatically
// If running at local machine, please create .env with REACT_APP_WEB_PORTAL_URL value (e.g.http://localhost:8080)
const serverUrl = process.env.REACT_APP_WEB_PORTAL_URL || '';

export const APIURL = `${serverUrl}/api`;
